import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { setDataSource } from "../../redux/reducers/RepertoireReducer";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { MemberPortalSearchTypeItem } from "../../redux/types/MemberPortalSearchTypeItem";
import { IMemberProductSearchResult } from "../types/IMemberProductSearchResult";
import CueSheetsPage from "../cueSheets/CueSheetsPage";
import { ICueSheetsSearchQuery } from "../types/ICueSheetsSearchQuery";
import { FormatFields } from "../../redux/types/FormatFields";
import { ICueSheetsSearchResult } from "../types/ICueSheetsSearchResult";
import { IMembersPortalPathInfo } from "../types/IMembersPortalPathInfo";
import { IMyPackagesDetails } from "../../repertoire/types/IMyPackagesDetails";
import { IAddtoPackageResult } from "../../repertoire/types/IAddtoPackageResult";
import { hideModal, showYesNoPrompt } from "../../redux/reducers/ModalReducer";

export interface IMyRegisteredCueSheetsPageProps {
    cueSheetsPageData?: IMembersPortalComponentDataItem;
    searchViewData: IMembersPortalComponentDataItem;
    searchResultsTableData: IMembersPortalComponentDataItem;
    searchCueSheets?: (query: ICueSheetsSearchQuery) => void;
    cueSheetsSearchResults?: ICueSheetsSearchResult[];
    memberSetListSearchResults?: IMemberProductSearchResult[];
    searchSuccessful: boolean;
    lookupValues: ILookupDictionary;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    sortSearchResults: (name: string, results: any) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    disabled?: boolean;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    setDataSource: typeof setDataSource;
    dataSource: string;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    currentUserNameNumber?: string;
    getCueSheetsDetails: (dataSource: string, productCoreId: number, lookupValues: ILookupDictionary, formats?: FormatFields[]) => void;
    memberPortalSearchType: MemberPortalSearchTypeItem;
    expandedProductResults: number[];
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location, tabs?: ITabReduxItem[], lookupValues?: ILookupDictionary) => void;
    expandAll: boolean;
    expandProductResult: (productResult: number) => void;
    expandAllResults: () => void;
    myPackagesResult?: IMyPackagesDetails[] | { data?: IMyPackagesDetails[]; };
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => Promise<IAddtoPackageResult>;
    removeFromPackages?: (userName: string, entityType: string, entityIds: number[]) => Promise<IAddtoPackageResult>;
    getMyPackagesDetails?: (userName: string) => void;
    showYesNoPrompt: typeof showYesNoPrompt;
    hideModal: typeof hideModal;
    fullCataloguePackagePending?: boolean;
    saveInProgress?: boolean;
    packageOperationInProgress?: boolean;
    createCueSheetPackageFromCriteria?: (userName: string, criteria: ICueSheetsSearchQuery) => Promise<IAddtoPackageResult>;
}

const MyRegisteredCueSheetsPage = (props: IMyRegisteredCueSheetsPageProps) => {
    const myRegisteredCueSheetsPage = CueSheetsPage
    return myRegisteredCueSheetsPage({
        cueSheetsPageData: props.cueSheetsPageData,
        searchViewData: props.searchViewData,
        searchResultsTableData: props.searchResultsTableData,
        searchCueSheets: props.searchCueSheets,
        cueSheetsSearchResults: null,
        memberCueSheetsSearchResults: props.cueSheetsSearchResults,
        searchSuccessful: props.searchSuccessful,
        lookupValues: props.lookupValues,
        indexOfFirstResult: props.indexOfFirstResult,
        indexOfLastResult: props.indexOfLastResult,
        resultsPerPage: props.resultsPerPage,
        currentPage: props.currentPage,
        resetPagination: props.resetPagination,
        updatePagination: props.updatePagination,
        sortSearchResults: props.sortSearchResults,
        defaultActiveAccordions: props.defaultActiveAccordions,
        allResultsPerPage: props.allResultsPerPage,
        updateUserPreferences: props.updateUserPreferences,
        disabled: props.disabled,
        setDataSource: props.setDataSource,
        dataSource: props.dataSource,
        activeTab: props.activeTab,
        tabs: props.tabs,
        currentUserNameNumber: props.currentUserNameNumber,
        memberPortalSearchType: props.memberPortalSearchType,
        registeredCueSheetsMaintenanceGeneralDataView: undefined,
        getCueSheetsDetails: props.getCueSheetsDetails,
        expandAll: props.expandAll,
        expandProductResult: props.expandProductResult,
        expandAllResults: props.expandAllResults,
        expandedProductResults: props.expandedProductResults,
        loadMembersPortalFromPath: props.loadMembersPortalFromPath,
        roles: props.roles,
        myPackagesResult: props.myPackagesResult,
        addToPackages: props.addToPackages,
        removeFromPackages: props.removeFromPackages,
        getMyPackagesDetails: props.getMyPackagesDetails,
        showYesNoPrompt: props.showYesNoPrompt,
        hideModal: props.hideModal,
        fullCataloguePackagePending: props.fullCataloguePackagePending,
        saveInProgress: props.saveInProgress,
        packageOperationInProgress: props.packageOperationInProgress,
        createCueSheetPackageFromCriteria: props.createCueSheetPackageFromCriteria,
    })
}

export default MyRegisteredCueSheetsPage;
